import { services } from "onearm";
import { GameStates } from "onearm";
import { SubGameState } from "./SubGameState";

export class Spinning extends SubGameState {
    enter({ result = null, disableSkip = false } = {}) {
        const spinType = this.data.spinType || "normal";
        const isQuickOrTurbo = spinType === "quick" || spinType === "turbo";
        const autoplayQuickSpin = this.autoplay.isActive() && this.autoplay.isQuickSpin;
        const autoplayTurboSpin = this.autoplay.isActive() && this.autoplay.isTurboSpin;

        this.isInstantSpin = isQuickOrTurbo || autoplayQuickSpin || autoplayTurboSpin;
        this.isTurboSpin = spinType === "turbo" || autoplayTurboSpin;

        this.sfx = services.audio.playSfx(this.isInstantSpin ? "spin_button_click" : "spin_button_click");
        this.startTime = Date.now();
        this.isSkiped = false;
        this.disableSkip = disableSkip;
        this.spinResult = result;
        this.executeSpin();

        if (!this.autoplay.isActive()) {
            this.hud.showInfo("GOOD LUCK!");
        } else {
            this.hud.showInfo(`AUTO SPINS LEFT: ${this.autoplay.getGamesLeft()}`);
        }

        this.hud.setStopState();
        this.addSignalHandler(this.hud.onPressStop, this.presStopHandler);
        this.addSignalHandler(this.keyboard.onSpacePress, this.skipSpin);

        if (this.isTurboSpin) {
            this.skipSpin();
        }
    }

    stopAutoplay() {
        if (this.autoplay.isActive()) {
            this.autoplay.stop();
        }
        this.hud.showAutoplayButton();
    }

    presStopHandler() {
        this.skipSpin();
        this.stopAutoplay();
    }

    async getSpinResult() {
        if (this.spinResult) {
            return Promise.resolve(this.spinResult);
        }

        return this.gameLogic.spin(this.data.bet);
    }

    async executeSpin() {
        try {
            this.spinTimeLine = this.reels.spin(this.isInstantSpin);

            if (this.data.spinType === "turbo") {
                this.spinTimeLine.timeScale(1.2);
            }

            const resultPromise = this.getSpinResult();

            this.updateBalance();

            this.spinResult = await resultPromise;
        } catch (e) {
            this.onServerError(e);
        }
    }

    updateBalance() {
        this.hud.setBalance(this.gameLogic.balance);
    }

    onServerError(error) {
        if (error.custom_message === "-1") {
            this.gameState.rejectSpin();
            this.gameState.goTo(GameStates.IDLE);
            return;
        }

        this.gameState.goTo(GameStates.ERROR, error);
    }

    skipSpin() {
        if (this.spinTimeLine && this.spinTimeLine.isActive()) {
            this.spinTimeLine.progress(1);
            this.isSkiped = true;
        }
    }

    update(dt) {
        super.update(dt);

        this.checkSpinEnd();
    }

    checkSpinEnd() {
        const result = this.spinResult;

        if (result && this.spinTimeLine && this.spinTimeLine.progress() === 1) {
            if (this.sfx && this.isSkiped) {
                this.sfx.stop();
            }
            const quickStop = this.isSkiped || this.isInstantSpin;
            this.gameState.goTo(GameStates.WINNING, { result, quickStop });
        }
    }

    exit() {
        super.exit();

        if (this.spinTimeLine) {
            this.spinTimeLine.kill();
            this.spinTimeLine = null;
        }
    }
}
